export default {
    PRIMARY: '#5422B3', //purple
    HEADER: '#262F56', //black
    PARAGRAPH: '#262F56', //dark grey
    LIGHT_BACKGROUND: '#F3F0F9', //light purple
    CONFIRM: '#C1F6B4', //green
    LIGHT_PARAGRAPH: 'rgba(0,0,0,0.5)' //50% black
}